import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumnWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconColumnWide"><Path d="M2 4H11V20H2V4Z" fill="currentColor"/><Path d="M13 4H22V20H13V4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumnWide;
